export default __webpack_public_path__ + "49442baded179145e04357eef95ad03f.svg";